

export const jobsQuery = {
  count: '',
  city_code: '',
  industry_code: '',
  page_size: 20, // 每页数量
  page: 1
};
const state = () => ({
  // 职位列表seo参数
  jobsQuery,
  jobs: [], // 职位列表
  cities: [], // 城市列表
  hot_cities: [], // 热门城市列表
  recruitInfos: [], // 职位列表数据
  isSearch: false, // 是否搜索
  intention: {}, // 意向内容全部类型
  pageTotal: 0, // 数量
  hostCity: [], // 底部热门城市列表
  hostIndustries: [], // 底部热门行业列表
  cityAction: '', // 选中的城市
  intentionAction: '', // 选中的
  searchValue: '', // 职位搜索-搜索内容
  industries: [], // 职位列表，行业分类
  userIntentions: {}, // 求职意向
});
export default state;